import { render, staticRenderFns } from "./organizationIndex.vue?vue&type=template&id=f5db05be&scoped=true&"
import script from "./organizationIndex.vue?vue&type=script&lang=js&"
export * from "./organizationIndex.vue?vue&type=script&lang=js&"
import style0 from "./organizationIndex.vue?vue&type=style&index=0&id=f5db05be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5db05be",
  null
  
)

export default component.exports